export const uniqueKey = () => Math.random().toString(36).slice(2, 9);
